import React, { Component } from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { get, size, cloneDeep } from "lodash";
import { Grid } from "@material-ui/core";
import schemas from "./content-types";
import Form from "../../Form";
// import firebase from "firebase";
import { createSubscription } from "../../../utils/db";

const useMock = false;

class ContentEntry extends Component {
  // constructor(props) {
  //   super(props);

  //   this.state = {
  //     schema: cloneDeep(schemas[props.match.params.schemaId]),
  //     formData: useMock
  //       ? require(`./content-types/${this.props.match.params.schemaId}`)
  //           .mockData
  //       : null
  //   };
  //   // this.formData = require(`./content-types/${this.props.match.params.schemaId}`).mockData;
  // }

  // componentDidMount = async () => {
  //   if (!useMock && this.props.match.params.entryId !== 'new') {
  //     try {
  //       const doc = await firebase
  //         .firestore()
  //         .collection(this.props.match.params.schemaId)
  //         .doc(this.props.match.params.entryId)
  //         .get();

  //       const formData = doc.data() || {};

  //       let schema = cloneDeep(schemas[this.props.match.params.schemaId]);

  //       if (schema && schema.extensions) {
  //         if (schema.extensions.onProp) {
  //           schema = schema.extensions.extend(
  //             formData[schema.extensions.onProp],
  //             schema
  //           );
  //         } else {
  //           console.warn(
  //             `Extensions found for schema: ${props.match.params.schemaId} but no onProp was specified`
  //           );
  //         }
  //       }

  //       this.setState({ formData, schema });
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   } else if (this.props.match.params.entryId === 'new') {
  //     this.setState({ formData: {} });
  //   }
  // };

  getData = () => {
    createSubscription(this.props.match.params.schemaId);
    return null;
  };

  getSchema = () => {
    const { schema, formData } = this.props;
    let formattedSchema = schema;
    if (schema && schema.extensions) {
      if (schema.extensions.onProp) {
        formattedSchema = schema.extensions.extend(
          formData[schema.extensions.onProp],
          schema
        );
      } else {
        console.warn(
          `Extensions found for schema: ${this.props.match.params.schemaId} but no onProp was specified`
        );
      }
    }
    return formattedSchema;
  };

  render() {
    if (!this.props.schema || !size(this.props.schema)) {
      return "No schema found";
    }

    return (
      <Grid container>
        <Grid item md={12}>
          {this.props.formData ? (
            <Form
              withPadding
              schema={this.getSchema()}
              formData={this.props.formData}
            />
          ) : (
            this.getData()
          )}
        </Grid>
      </Grid>
    );
  }
}

export default connect(
  (
    { dbState },
    {
      match: {
        params: { schemaId, entryId }
      }
    }
  ) => ({
    formData:
      entryId === "new" ? {} : get(dbState, `${schemaId}.${entryId}`, {}),
    schema: cloneDeep(schemas[schemaId])
  }),
  {}
)(hot(module)(ContentEntry));
